import { memo } from 'react';
import MuiTabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import TabScrollButton from '@mui/material/TabScrollButton';

const StyledTabs = styled(MuiTabs)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  '& .MuiTabs-indicator': {
    backgroundColor: '#87C8E0',
    height: 3,
  },
}));

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  color: '#DDDDDD',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: '24px',
  fontWeight: 500,
  padding: '0 16px',
  minWidth: 72,
  '&.Mui-selected': {
    color: '#87C8E0',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(12),
    padding: '0 8px',
  },
}));

const CustomScrollButton = (props) => {
  if (props.disabled) {
    return null;
  }
  return <TabScrollButton {...props} sx={{ opacity: props.disabled ? 0 : 1 }} />;
};

const Tabs = ({ tabs, value, onChange }) => (
  <StyledTabs
    value={value}
    onChange={onChange}
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
    ScrollButtonComponent={CustomScrollButton}
    TabIndicatorProps={{
      sx: { backgroundColor: '#87C8E0' },
    }}
  >
    {tabs.map((tab) => (
      <StyledTab key={tab.value} label={tab.label} value={tab.value} />
    ))}
  </StyledTabs>
);

export default memo(Tabs);
